import { render, staticRenderFns } from "./my-notice.vue?vue&type=template&id=ded9f152&scoped=true&"
import script from "./my-notice.vue?vue&type=script&lang=js&"
export * from "./my-notice.vue?vue&type=script&lang=js&"
import style0 from "./my-notice.vue?vue&type=style&index=0&id=ded9f152&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ded9f152",
  null
  
)

component.options.__file = "my-notice.vue"
export default component.exports